import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "../components/site/Logo";
import { api, apiError } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin");
    } catch (e2) {
      setErr(apiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center bg-[#060a14] px-5 grid-bg">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm glass rounded-3xl p-7">
        <Logo />
        <h1 className="mt-6 font-display font-extrabold text-2xl text-white">Area riservata</h1>
        <p className="mt-1 text-sm text-slate-400">Accedi al pannello di gestione del sito.</p>
        <input data-testid="admin-login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
          className="mt-6 w-full h-12 rounded-xl bg-white/[0.04] border hairline px-4 text-white outline-none focus:border-[#4fc3f7]/60" />
        <input data-testid="admin-login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
          className="mt-3 w-full h-12 rounded-xl bg-white/[0.04] border hairline px-4 text-white outline-none focus:border-[#4fc3f7]/60" />
        {err && <p data-testid="admin-login-error" className="mt-3 text-sm text-red-400">{err}</p>}
        <button data-testid="admin-login-submit" disabled={loading} className="mt-5 w-full h-12 rounded-xl bg-[#ff5500] hover:bg-[#ff6a1f] text-white font-semibold grid place-items-center">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Accedi"}
        </button>
      </form>
    </main>
  );
}
